export default __webpack_public_path__ + "static/media/timerIcon.f7aa8c99.svg";